import { FC } from 'react';

type AnchorDestinationProps = {
  anchorId: string;
};

const AnchorDestination: FC<AnchorDestinationProps> = ({ anchorId }) => <div id={anchorId} />;

export default AnchorDestination;
